import React, { useState } from 'react';
import './Venue.scss';
import { Link } from 'react-router-dom';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import video from '../../assets/video/video.mp4';

const Venue = () => {
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };

  return (
    <div className="venue">
      <div className="left-container">
        <p className="title">Mesto održavanja</p>
        <a href="https://www.hotelzlatibor-resort.com/" className="sub-title">
          HOTEL ZLATIBOR
        </a>
        <p className="text">
          Hotel Zlatibor**** smešten u samom srcu zlatne planine, predstavlja magičan spoj tradicije
          i moderno dizajniranog prostora. Lidersku poziciju je stekao zahvaljujući optimalnom
          balansu sadržaja uz relaksaciju i smeštajnih i kongresnih kapaciteta, koji savršeno
          odgovaraju organizaciji svih poslovnih događaja. Pored idealne lokacije, dodatnu lepotu
          uživanja pruža ogromna mogućnost izbora od 260 savremeno opremljenih hotelskih soba i
          apartmana koje nude različit doživljaj odmora, a svaku od njih odlikuje rustičan,
          planinski stil, upotpunjen dozom luksuza i elegancije. <br />
          <br /> Kada su u pitanju hotelski sadržaji za odmor, posebno se ističe luksuzni Magnesium
          Wellness & Spa centar na čak 4.000 kvadrata, sa lekovitom vodom bogatom magnezijumom,
          kalijumom, kalcijumom i ostalim mineralima koji pozitivno deluju na zdravlje. Pored Lobby
          bara koji zauzima centralno mesto hotela, koje odiše toplinom i planinskim duhom,
          gastronomski doživljaj upotpunjuju a la carte restoran Kalem by ZAK Mountain Concept, i
          pansionski restoran RUJ. Gostima je na raspolaganju i najsavremenije opremljen fitnes
          centar, kuglana, bilijar sala, kao i pažljivo osmišljena igraonica za naše najmlađe.
        </p>

        {/* <div className="btn-container">
          <Link
            to={'/accommodation'}
            style={isHovering ? { color: '#0D4077' } : {}}
            className="btn">
            POGLEDAJTE VIŠE
          </Link>
        </div> */}
      </div>
      <div className="right-container">
        <div className="image-wrapper">
          {/* <Link to={'/accommodation'}> */}
          <video
            className="video"
            autoPlay={true}
            muted={true}
            playsInline={true}
            loop={true}
            height="500px"
            src={video}
          />
          {/* </Link> */}
        </div>
        {/* <div className="btn-container-mobile">
          <Link
            to={'/accommodation'}
            style={isHovering ? { color: '#0D4077' } : {}}
            className="btn-mobile">
            POGLEDAJTE VIŠE
          </Link>
        </div> */}
      </div>
    </div>
  );
};

export default Venue;
